import { useLingui } from "@lingui/react/macro";
import { Badge } from "@offstreetparking/design-system/dataDisplay/Badge";
import { ProhibitedIcon } from "@offstreetparking/design-system/icons/ProhibitedIcon";
type CapacityFullBadgeProps = {
	label?: string;
};

export const CapacityFullBadge = ({ label }: CapacityFullBadgeProps = {}) => {
	const { t } = useLingui();
	return (
		<Badge variant="critical" size="sm" icon={ProhibitedIcon}>
			{label ?? t`No Permits Available`}
		</Badge>
	);
};
